import React from 'react';

import useGetUserSettingsQuery from 'hooks/domain/user/queries/useGetUserSettingsQuery';

import { useUtilityConnectEnablement } from '../../../hooks/domain/utilityConnect/useUtilityConnectEnablement';

import type { IntegrationState } from './types';
import { useHasShown } from './useHasShown';

export function useShowUtilityConnect(): IntegrationState & { isEligible?: boolean; isEnabled?: boolean } {
  const userSettings = useGetUserSettingsQuery();
  const utilityConnect = useUtilityConnectEnablement();

  const shouldShow = React.useMemo(
    () => utilityConnect.isEligible === true && utilityConnect.isEnabled === false,
    [utilityConnect.isEligible, utilityConnect.isEnabled]
  );

  const hasShown = useHasShown(shouldShow);

  return {
    isLoading: userSettings.isLoading || utilityConnect.isLoading,
    show: shouldShow,
    hasShown,
    isEligible: utilityConnect.isEligible,
    isEnabled: utilityConnect.isEnabled,
  };
}
